import React, { useRef, useState } from "react";
import { usePrefersReducedMotion } from "@sscs/ui";
import { cssVars } from "@sscs/ui/styles";
import { motion } from "framer-motion";
import { ANIMATION_DURATION } from "../../../../constants";
import { getLevelPrefix } from "../../../../utils";
import styles from "./levelDiamond.module.scss";
const AttainedLevel = ({ level, inhibitors, }) => {
    const prefersReducedMotion = usePrefersReducedMotion();
    const [attainedLevel5Animation, setAttainedLevel5Animation] = useState(false);
    const backgroundPosition = useRef(null);
    const showsLevel5 = attainedLevel5Animation || (prefersReducedMotion && level === 5);
    const levelPrefix = getLevelPrefix(inhibitors.customized);
    const attainedBackgroundVariant = {
        start: { backgroundPosition: "100%" },
        end: {
            backgroundPosition: "0%",
            transition: {
                duration: ANIMATION_DURATION,
            },
        },
    };
    const attainedTextVariant = {
        // Theme-reactive var() refs (not baked `variables`, which is frozen to
        // light): framer resolves them against the element's computed style, so the
        // text is dark ink in light mode and light ink in dark, always readable as
        // the fill wipes in underneath it.
        start: { color: cssVars.text_primary },
        end: {
            color: cssVars.text_inverse,
            transition: {
                duration: ANIMATION_DURATION,
            },
        },
    };
    // Transition defined separately to get type safety
    const attainedLevel5AnimationRotationTransition = {
        duration: 3,
        repeat: Infinity,
        repeatType: "loop",
        type: "keyframes",
        ease: "linear",
    };
    // Have to use any: https://www.framer.com/motion/component/###animating-css-variables
    const attainedLevel5AnimationVariant = {
        initial: {
            "--transform-gradient": "none",
            "--color": cssVars.text_primary,
            "--color-2": cssVars.text_primary,
            "--glow-color": "transparent",
            "--scale": "scale(0.92)",
        }, // eslint-disable-line @typescript-eslint/no-explicit-any
        rotation: {
            "--transform-gradient": "rotate(1turn)",
            transition: attainedLevel5AnimationRotationTransition,
        }, // eslint-disable-line @typescript-eslint/no-explicit-any,
        opacity: {
            // The nitro celebration sweep (design canvas 4b): the ring fades from
            // ink to the brand pink→violet gradient with a magenta halo.
            "--color": cssVars.nitro_gradient_start,
            "--color-2": cssVars.nitro_gradient_end,
            "--glow-color": cssVars.celebration_glow,
            transition: {
                duration: 1,
            },
        }, // eslint-disable-line @typescript-eslint/no-explicit-any,
        scale: {
            "--scale": "scale(1)",
            transition: {
                duration: 1,
            },
        }, // eslint-disable-line @typescript-eslint/no-explicit-any,
    };
    if (showsLevel5)
        return (React.createElement(motion.div, { initial: prefersReducedMotion ? false : "initial", animate: prefersReducedMotion
                ? ["scale", "opacity"]
                : ["rotation", "scale", "opacity"], variants: attainedLevel5AnimationVariant, className: styles["attained-level-5"] },
            React.createElement("div", { className: styles.text },
                levelPrefix,
                level)));
    return (React.createElement("div", { className: styles.level },
        React.createElement(motion.div, { variants: attainedBackgroundVariant, className: styles["attained-level"], onUpdate: (latest) => {
                backgroundPosition.current = latest.backgroundPosition;
            }, onAnimationComplete: () => {
                if (level === 5 && backgroundPosition.current === "0%")
                    setAttainedLevel5Animation(true);
            } },
            React.createElement(motion.div, { variants: attainedTextVariant, className: styles["level-content"] },
                levelPrefix,
                level))));
};
export default AttainedLevel;
//# sourceMappingURL=AttainedLevel.js.map